
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[id]/[[...slug]]",
      function () {
        return require("private-next-pages/articles/[id]/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[id]/[[...slug]]"])
      });
    }
  